import { answerActionTypes } from '@actions/actionTypes/answer';
import { answerInitialState, AnswerState } from './initialState/answer';
import { AnyAction } from 'redux';

export const answerReducer = (state = answerInitialState, action: AnyAction): AnswerState => {
  switch (action.type) {
    case answerActionTypes.CREATE_ANSWER_LOADING: {
      return { ...state, isCreateAnswerLoading: action.payload };
    }
    case answerActionTypes.CURRENT_ANSWER_LOADING: {
      return { ...state, isCurrentAnswerLoading: action.payload };
    }
    case answerActionTypes.SET_CURRENT_ANSWER: {
      return { ...state, currentAnswer: action.payload };
    }
    case answerActionTypes.CURRENT_ANSWER_FAILURE: {
      return { ...state, isCurrentAnswerFailure: action.payload };
    }
    case answerActionTypes.SET_EDIT_MODE: {
      return { ...state, editMode: action.payload };
    }
    case answerActionTypes.ANSWERS_LOADING: {
      return { ...state, isAnswersLoading: action.payload };
    }
    case answerActionTypes.SET_ANSWERS: {
      return { ...state, answers: action.payload };
    }
    case answerActionTypes.ANSWERS_FAILURE: {
      return { ...state, isAnswersFailure: action.payload };
    }
    case answerActionTypes.SET_ANSWERS_TOTAL: {
      return { ...state, total: action.payload };
    }
    case answerActionTypes.SET_CHECKED_ANSWERS: {
      return {
        ...state,
        checkedAnswersIds: [...Array.from(new Set(action.payload as string[]))],
      };
    }
    case answerActionTypes.SET_NAVIGATE_TO_ID: {
      return {
        ...state,
        navigateId: action.payload,
      };
    }
    ///// ------ POST/PUT/DELETE ----- ////
    case answerActionTypes.EDITING_ANSWER_LOADING: {
      return { ...state, isEditingAnswerLoading: action.payload };
    }
    case answerActionTypes.SET_EDITING_ANSWER: {
      return { ...state, editingAnswer: action.payload };
    }
    case answerActionTypes.EDITING_ANSWER_FAILURE: {
      return { ...state, isEditingAnswerFailure: action.payload };
    }
    case answerActionTypes.DELETING_ANSWERS_LOADING: {
      return { ...state, isDeletingAnswersLoading: action.payload };
    }
    case answerActionTypes.MARKING_AS_SENT_LOADING: {
      return { ...state, isMarkingAsSentLoading: action.payload };
    }
    case answerActionTypes.DELETING_ANSWERS_FAILURE: {
      return { ...state, isDeletingAnswersFailure: action.payload };
    }

    case answerActionTypes.SET_IS_DATE_FROM_SAVED: {
      return {
        ...state,
        isDateFromSaved: action.payload,
      };
    }
    case answerActionTypes.SET_IS_DATE_TO_SAVED: {
      return {
        ...state,
        isDateToSaved: action.payload,
      };
    }
    case answerActionTypes.SET_DATE_FROM_OLD: {
      return {
        ...state,
        dateFromOld: action.payload,
      };
    }
    case answerActionTypes.SET_DATE_TO_OLD: {
      return {
        ...state,
        dateToOld: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
